<template>
    <div>
        <div id="owner-panel">
            <div class="owner-panel-container">
                <div class="headerOfDriverFlow">
                    <div class="header__wrapper">
                        <div class="header__logo">
                            <img src="@/assets/icons/login__logo.svg">
                        </div>
                        <div class="header__logout" @click="logout">
                            <div class="logout__icon">
                                <img src="@/assets/icons/ic_logout-blue.svg">
                            </div>
                            <div class="logout__text">
                                {{translate('Logout')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="content__wrapper">
                        <div class="content__text">
                            {{translate('driverMainText', [this.userInfo.email, this.userInfo.organization.official_name])}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapActions, mapState, mapMutations} from "vuex";
    import logAnalyticsEvent from '@/helpers/analytics';
    import errorMixin from "@/mixins/errorMixin";


    export default {
        mixins: [errorMixin],
        name: "driverFlow",
        data() {
            return {

            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.auth.userInfo,
            })
        },
        methods: {
            ...mapActions({
                logoutRemote: 'auth/logout',
            }),
            ...mapMutations({
                removeKeys: 'auth/removeKeys',
            }),
            async logout() {
                logAnalyticsEvent('settings_logout_click')
                try {
                    await this.logoutRemote()
                } catch (error) {
                    console.log('error', error)
                } finally {
                    this.removeKeys()
                    this.$store.commit('owner/setOwner', false)
                    this.$router.push('/sign-in')
                }
            },
        }
    }
</script>

<style scoped>
    .header__wrapper {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }
    .header__logout {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .logout__icon {
        margin-right: 5px;
    }
    .content__wrapper {
        width: 100%;
        margin-top: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
</style>